import { render, staticRenderFns } from "./ResultModal.vue?vue&type=template&id=893ca26a"
import script from "./ResultModal.vue?vue&type=script&lang=js"
export * from "./ResultModal.vue?vue&type=script&lang=js"
import style0 from "./ResultModal.vue?vue&type=style&index=0&id=893ca26a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports